import { useCallback, useState } from 'react';
import { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { AccrualDate } from 'repository/timekeeper/@types/AccrualDate';

export const useAccrualDatesTableState = () => {
    const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);
    const [selectedRow, setSelectedRow] = useState<AccrualDate[]>([]);
    const [selected, setSelected] = useState<GridRowSelectionModel>([]);

    const cleanSelected = useCallback(() => {
        setSelectedRow([]);
        setSelected([]);
    }, []);

    return {
        contextMenu,
        setContextMenu,
        selectedRow,
        setSelectedRow,
        selected,
        setSelected,
        cleanSelected,
    };
};
